import React, { useState } from "react";
import "./CustomGrid.scss";
import SeamlessBra from '../assets/images/seamless bra.webp';
import SeamlessTshirt from '../assets/images/seamless tshirt.jpg';
import SeamlessLeggins from '../assets/images/seamless leggins.jpg';
import SeamlessTopsAndShort from '../assets/images/seamless tops and shorts.jpg';
import SeamlessCompresive from '../assets/images/seamless compresive.jpg';
import SeamlessShapewear from '../assets/images/seamless shapewear.jpg';
import SeamlessUnderwear from '../assets/images/seamless underwear.webp';
import SeamlessActivewear from '../assets/images/seamless activewear.jpg';
import SubmitDesign from "./SubmitDesign";


const CustomGrid = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState<"design" | "catalog" | "needs">("design");

  const openModal = (type: "design" | "catalog" | "needs") => {
    setModalType(type);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const categories = [
    { title: "Seamless Bra", image: SeamlessBra },
    { title: "Seamless T Shirts", image: SeamlessTshirt },
    { title: "Seamless Leggings", image: SeamlessLeggins },
    { title: "Tops & Shorts Sets", image: SeamlessTopsAndShort },
    { title: "Compression Clothing", image: SeamlessCompresive },
    { title: "Seamless Shapewear", image: SeamlessShapewear },
    { title: "Seamless Underwear", image: SeamlessUnderwear },
    { title: "Seamless Activewear", image: SeamlessActivewear },
  ];

  return (
    <>
    <div className="custom-grid">
      <h2>Custom Seamless Clothing Wholesale Range</h2>
      <p>
        Customize your own seamless knitting design at the Lowest MOQ in the
        industry!
      </p>

      <div className="grid-container">
        {categories.map((category, index) => (
          <div key={index} className="grid-item">
            <div className="image-container">
              <img src={category.image} alt={category.title} />
              <div className="overlay">
                <span>{category.title}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <button onClick={() => openModal("needs")} className="submit-button">SUBMIT YOUR NEEDS</button>
    </div>
    {isModalOpen && <SubmitDesign closeModal={closeModal} formType={modalType} />}
    </>
    
  );
};

export default CustomGrid;
